export enum FeatureFlagKeys {
    NewAuthPagerModal = 'ff_new_auth_pager_modal',
    NewBiddingConsoleLayout = 'ff_laac_756_live-bidding-experience-redesign',
}
// TODO: Add feature flags here
// NewItemPageLayout = 'ff_laac-5678_new-item-page-layout',

export type FeatureFlags = Partial<Record<FeatureFlagKeys, boolean>>;
